import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import * as style from './style.css';
import { UIText3, Tooltip } from '@cian/ui-kit';
import { clsx } from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
export var FloorsPanelTooltip = function FloorsPanelTooltip(_ref) {
  var isDisabled = _ref.isDisabled,
    title = _ref.title,
    children = _ref.children;
  var floorDescription = isDisabled ? 'Нет квартир на этаже' : title;
  return /*#__PURE__*/_jsx(Tooltip, {
    theme: "white",
    placement: "bottom",
    title: /*#__PURE__*/_jsx("div", {
      className: clsx(style['tooltip-content'], _defineProperty({}, style['tooltip-content-disabled'], isDisabled)),
      children: /*#__PURE__*/_jsx(UIText3, {
        textAlign: "center",
        children: floorDescription
      })
    }),
    children: children
  });
};